import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { useApiScope } from '../../scope';
import { IManagedFilingsStatus } from './types';

export function useManagedFilingsStatus({
  corporationId,
  shouldFetch,
}: {
  corporationId: number;
  shouldFetch: boolean;
}) {
  const { shareToken } = useApiScope();

  const { data, error }: { data?: IManagedFilingsStatus; error?: unknown } =
    useSWR(
      shouldFetch
        ? `new-sales-tax/registrations-v2/managed-filings-status?corporationId=${corporationId}`
        : null,
      SWRFetcher({ method: 'GET', shareToken })
    );

  return { data, error };
}
